import { create } from 'zustand';

interface StoreStates {
  isAISearchActive: boolean;
}

interface Store extends StoreStates {
  setIsAISearchActive: (isActive: boolean) => void;

  reset: () => void;
}

const initalState: StoreStates = {
  isAISearchActive: false
};

export const useCatalogStore = create<Store>(set => ({
  ...initalState,

  setIsAISearchActive: (isActive: boolean) =>
    set({ isAISearchActive: isActive }),
  reset: () => set({ ...initalState })
}));
